var _path, _rect, _rect2, _rect3, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxPlot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "8 8 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9V57H56",
    stroke: "#B3B3B3",
    strokeWidth: 0.990534,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 34,
    height: 1.09091,
    fill: "#B3B3B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 49.9091,
    width: 33.8182,
    height: 1,
    transform: "rotate(-90 32 49.9091)",
    fill: "#B3B3B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 49.9091,
    width: 34,
    height: 1.09091,
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33L49 21L15 21L15 33L49 33Z",
    fill: "#3B82C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 45L49 33L15 33L15 45L49 45Z",
    fill: "#8CBFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxPlot);
export default __webpack_public_path__ + "static/media/box_plot.7b1e1b0e.svg";
export { ForwardRef as ReactComponent };